// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_f1-0";
export var headerCellHover = "_f1-1";
export var readCellContainer = "_f1-2";
export var unreadIndicator = "_f1-3";